<template>
	<include-header />

	<section id="lab_mypage">
		<div class="content">
			<div class="contIn">
				<div class="sub_cont sub_cont1">
					<div class="boardTit">회원정보</div>
					<div class="sub_contBox">
						<div class="infoForm">
							<div class="caution">
								<p class="icon_notice"></p>
								<p>사업자정보 변경 시, <strong>고객센터 info@wetree.kr</strong>로 문의 바랍니다.</p>
							</div>

							<form ref="form_my_update" id="form_my_update" :action="`${SERVER_URL}/api/app/member`"
								@submit.prevent="form_my_update_submit()" method="post" enctype="multipart/form-data"
								autocomplete="off">
								<input type="hidden" v-model="form.mb_hp" id="mb_hp">
								<input type="hidden" v-model="form.cert_no">
								<input type="hidden" v-model="form.hp_cert" id="hp_cert">
								<input type="hidden" v-model="form.mb_busi_num" id="mb_busi_num">
								<input type="hidden" v-model="ischanged_email" id="ischanged_email">
								<input type="hidden" v-model="ischanged_phone" id="ischanged_phone">

								<table>
									<tbody>
										<tr>
											<td class="memberCols1"><label for="reg_mb_id">아이디<span class="essential"></span></label></td>
											<td class="memberCols2">
												<input type="text" v-model="form.mb_id" id="reg_mb_id" class="wcalc mypage_id w100" placeholder="아이디" minlength="3" maxlength="20" autocomplete="off" readonly="">
											</td>
										</tr>
										<tr>
											<td class="memberCols1"><label for="reg_mb_name">성명<span class="essential"></span></label></td>
											<td class="memberCols2">
												<input type="text" v-model="form.mb_name" id="reg_mb_name" class="w100" placeholder="성명" required="">
											</td>
										</tr>
										<tr>
											<td class="memberCols1"><label for="reg_mb_password">비밀번호 수정<span class="essential"></span></label></td>
											<td class="memberCols2">
												<input type="password" v-model="form.mb_password" id="reg_mb_password" class="w100" placeholder="비밀번호" minlength="8" maxlength="16" autocomplete="new-password">
												<div class="required_info">* 비밀번호는 8~16자 <span class="text-orange">영문, 숫자, 특수문자 필수</span><br>
													* 비밀번호 변경시에만 입력하세요</div>
											</td>
										</tr>
										<tr>
											<td class="memberCols1"><label for="reg_mb_password_re">비밀번호 확인<span class="essential"></span></label></td>
											<td class="memberCols2">
												<input type="password" v-model="form.mb_password_re" id="reg_mb_password_re" class="w100" placeholder="비밀번호 확인" minlength="8" maxlength="16" autocomplete="new-password">
											</td>
										</tr>
									<template v-if="globaljs.mb_staff === null || globaljs.mb_staff.length > 6">
										<tr>
											<td class="memberCols1">이메일<span class="essential"></span></td>
											<td class="memberCols2">
												<input type="hidden" v-model="old_email" id="old_email">
												<input type="email" class="wcalc disabled" disabled="" :value="old_email" placeholder="이메일">
												<input type="button" id="email_change_btn" @click="email_change_onclick()" class="join_form_btn email_edit_btn" value="변경">

												<div class="email_change_box">
													<div class="memberCols2 email">
														<input type="email" v-model="form.mb_email" id="mb_email" class="wcalc" disabled="" maxlength="50" @input="email_oninput" placeholder="이메일">
														<input type="button" id="reg_mb_email_check" class="join_form_btn" @click="email_check_submit()" value="중복확인">
													</div>
												</div>
											</td>
										</tr>
										<tr>
											<td class="memberCols1">휴대전화<span class="essential"></span>
												<div>
													<small v-show="ischanged_phone" class="required changed">
														변경 &check;
													</small>
													<small v-show="!ischanged_phone" class="required">
														{{ (form.hp_cert != 0 && form.mb_hp != '') ? '인증 &check;' : '미인증' }}
													</small>
												</div>
											</td>
											<td class="memberCols2 phone">
												<select v-model="old_phone1" id="old_phone1" class="phone1 disabled" disabled="">
													<option :selected="old_phone1 === '010'">010</option>
													<option :selected="old_phone1 === '011'">011</option>
													<option :selected="old_phone1 === '016'">016</option>
													<option :selected="old_phone1 === '017'">017</option>
													<option :selected="old_phone1 === '018'">018</option>
													<option :selected="old_phone1 === '019'">019</option>
													<option :selected="old_phone1 === '070'">070</option>
												</select>
												<span class="hyphen">-</span><input type="text" data-type="number" v-model="old_phone2" id="old_phone2" class="phone2 disabled" disabled="" maxlength="4" @input="handleMaxLengthCheck">
												<span class="hyphen">-</span><input type="text" data-type="number" v-model="old_phone3" id="old_phone3" class="phone3 disabled" disabled="" maxlength="4" @input="handleMaxLengthCheck">
												<input type="button" id="phone_change_btn" @click="phone_change_onclick()" class="join_form_btn hp_edit_btn" value="변경">

												<div class="phone_change_box">
													<div class="memberCols2 phone">
														<select v-model="form.phone1" id="phone1" class="phone1" required="" :readonly="form.readonly_phone">
															<option selected="">010</option>
															<option>011</option>
															<option>016</option>
															<option>017</option>
															<option>018</option>
															<option>019</option>
															<option>070</option>
														</select>
														<span class="hyphen">-</span>
														<input type="text" data-type="number" v-model="form.phone2" id="phone2" class="phone2" required="" :readonly="form.readonly_phone" maxlength="4" @input="handleMaxLengthCheck">
														<span class="hyphen">-</span>
														<input type="text" data-type="number" v-model="form.phone3" id="phone3" class="phone3" @keyup.enter.prevent="req_checknum()" required="" :readonly="form.readonly_phone" maxlength="4" @input="handleMaxLengthCheck">
														<input type="button" id="req_checknum_btn" @click="req_checknum()" v-show="form.show_req_checknum_btn" class="join_form_btn" value="인증번호 발송">
														<div v-if="clientIP === '182.219.119.124'" class="required_info">* [위트리IP에서만 보임] 두번째 칸 첫 숫자를 0,1,2로 시작하면 실제 발송되지 않음</div>
													</div>
													<div id="checknum_wrap" class="memberCols2 checknum checknum_wrap">
														<input type="text" data-type="number" v-model="form.checknum" id="checknum" @keyup.enter.prevent="cert_sms_check()" placeholder="인증번호 6자리" maxlength="6" @input="handleMaxLengthCheck">
														<input type="button" id="checknum_confirm" @click="cert_sms_check()" class="join_form_btn" value="확인">
													</div>
												</div>
											</td>
										</tr>
										<tr>
											<td class="memberCols1"><label for="mb_tel">대표 전화번호<span class="essential"></span></label></td>
											<td class="memberCols2">
												<input type="text" v-model="form.mb_tel" id="mb_tel" class="w100" placeholder="대표 전화번호 입력" required="" maxlength="15" @input="handleMaxLengthCheck">
												<div class="required_info">* 대표 전화번호는 최대 15자 숫자 또는 하이픈(-)</div>
											</td>
										</tr>
										<!-- 240426 추가 [계좌정보 추가 / 기공소페이지에서만 노출] -->
										<tr v-if="globaljs.acc_type === 'lab'" class="bank_info">
											<td class="memberCols1"><label for="mb_bank">계좌정보<span class="essential"></span></label></td>
											<td class="memberCols2">
												<div><label for="mb_bank">은행명</label><input type="text" v-model="form.mb_bank" id="mb_bank" class="w100" placeholder="은행명 입력" required="" maxlength="50" @input="handleMaxLengthCheck"></div>
												<div><label for="mb_bank_acc">계좌번호</label><input type="text" v-model="form.mb_bank_acc" id="mb_bank_acc" class="w100" placeholder="계좌번호 입력" required="" maxlength="20" @input="handleMaxLengthCheck"></div>
												<div><label for="mb_bank_name">예금주명</label><input type="text" v-model="form.mb_bank_name" id="mb_bank_name" class="w100" placeholder="예금주명 입력" required="" maxlength="15" @input="handleMaxLengthCheck"></div>
											</td>
										</tr>
										<!-- 240426 추가 끝 -->
									</template>
										<tr>
											<td class="memberCols1"><label for="busi_num1">사업자등록번호<span class="essential"></span></label></td>
											<td class="memberCols2 dental_num">
												<input type="text" data-type="number" id="busi_num1" class="disabled" disabled="" :value="form.busi_num1" maxlength="3" @input="handleMaxLengthCheck"><span class="hyphen">-</span>
												<input type="text" data-type="number" id="busi_num2" class="disabled" disabled="" :value="form.busi_num2" maxlength="2" @input="handleMaxLengthCheck"><span class="hyphen">-</span>
												<input type="text" data-type="number" id="busi_num3" class="disabled" disabled="" :value="form.busi_num3" maxlength="5" @input="handleMaxLengthCheck">
											</td>
										</tr>
										<tr>
											<td class="memberCols1">사업자등록증<span class="essential"></span></td>
											<td class="memberCols2">
												<img v-if="form.mb_img" :src="`${SERVER_URL}/images/member/${form.mb_img}`" alt="사업자등록증" width="248" height="350">
											</td>
										</tr>
										<tr>
											<td class="memberCols1"><label for="reg_mb_busi_name">상호<span class="essential"></span></label></td>
											<td class="memberCols2">
												<input type="hidden" v-model="form.mb_busi_name" id="reg_mb_busi_name">
												<input type="text" class="wcalc mypage_id w100" disabled="" :value="form.mb_busi_name">
											</td>
										</tr>
										<tr>
											<td class="memberCols1"><label for="reg_mb_busi_boss">대표자<span class="essential"></span></label></td>
											<td class="memberCols2">
												<input type="hidden" v-model="form.mb_busi_boss" id="reg_mb_busi_boss">
												<input type="text" class="mypage_id w100" disabled="" :value="form.mb_busi_boss">
											</td>
										</tr>
										<tr>
											<td class="memberCols1"><label for="reg_mb_busi_addr">소재지<span class="essential"></span></label></td>
											<td class="memberCols2">
												<input type="text" id="reg_mb_busi_addr" class="mypage_id w100" disabled="" :value="form.mb_busi_addr">
											</td>
										</tr>

										<tr>
											<td class="memberCols1"><label for="reg_mb_icon">프로필 사진</label></td>
											<td class="memberCols2">
											<template v-if="globaljs.mb_staff === null || globaljs.mb_staff.length > 6">
												<input type="file" ref="mb_icon" id="reg_mb_icon" :class="{ 'disabled' : form.mb_icon != null }" @change="updatePhoto('mb_icon')" class="wcalc" accept="image/gif, image/jpeg, image/png">
												<input type="button" v-show="form.mb_icon != null" @click="resetPhoto2" class="join_form_btn" value="삭제">
												<div class="required_info">* png, jpg, jpeg, gif 파일만 등록 가능 (3MB 이하) / 가로
													300px, 세로 300px 이하 권장</div>

												<div v-if="old_icon">
													<img :src="`${SERVER_URL}/images/member/${old_icon}`" alt="프로필 사진" style="max-width:80px; margin:1rem auto 0.5rem auto;">
													<div style="display:flex; align-items: center;">
														<input type="checkbox" v-model="form.del_mb_icon" id="del_mb_icon" true-value="Y">
														<label for="del_mb_icon" class="inline">삭제</label>
													</div>
												</div>
											</template>
											<template v-else>
												<div v-if="old_icon">
													<img :src="`${SERVER_URL}/images/member/${old_icon}`" alt="프로필 사진" style="max-width:80px; margin:1rem auto 0.5rem auto;">
												</div>
											</template>
											</td>
										</tr>
									</tbody>
								</table>
								<button type="button" id="btn_submit" class="member_edit_btn btn_style1"
									style="display:block;" @click.prevent="form_my_update_submit">회원 정보 수정</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, onBeforeUnmount, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as commonjs from '@/components/utils/common';
import * as globaljs from '@/components/utils/global';
import * as registerjs from '@/components/utils/register';

const route = useRoute();
const router = useRouter();

const clientIP = ref(null);

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const form = ref({
	mb_id: "",
	mb_password: "",
	mb_password_re: "",
	mb_name: "",
	mb_email: "",
	checked_email: "",
	phone1: "010",
	phone2: "",
	phone3: "",
	mb_hp: "",
	sended_hp: "",
	certed_hp: "",
	checknum: "",
	readonly_phone: false,
	cert_no: "",
	mb_tel: "",
	mb_bank: '',
	mb_bank_acc: '',
	mb_bank_name: '',
	mb_busi_num: '',
	mb_busi_name: '',
	mb_busi_boss: '',
	mb_busi_addr: '',
	mb_img: null,
	mb_icon: null,
	del_mb_icon: '',
	preview: null,
	preview2: null,
	hp_cert: 0,
	hp_check: 0,
	email_cert: 0,
	email_check: 0,
	timeout: false,
	mb_level: 1,
	busi_num1: "",
	busi_num2: "",
	busi_num3: "",
	show_req_checknum_btn: false
});

// 이벤트 핸들러 함수 정의
function handleMaxLengthCheck(event) {
	maxLengthCheck(event, form); // `form`이 `ref`로 전달됨
}

function handleValueCheck(event) {
	valueCheck(event, form); // `form`이 `ref`로 전달됨
}

// `maxLengthCheck` 함수 정의
function maxLengthCheck(event, dataObjectRef) {
	const object = event.target;

	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// 나머지 함수 로직...
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 숫자만 허용하는 경우, 숫자가 아닌 문자 제거
	if (object.dataset.type === 'number') {
		object.value = object.value.replace(/\D/g, '');
	}

	// maxLength 제한이 있는 경우, 입력 길이를 제한
	if (object.maxLength) {
		if (object.value.length > object.maxLength) {
			object.value = object.value.slice(0, object.maxLength);
		}
	}

	// `modelName`이 `dataObjectRef.value`에 있는지 확인
	try {
		if (modelName in dataObjectRef.value) {
			dataObjectRef.value[modelName] = object.value; // 데이터 모델 업데이트
			// console.log(`Updated ${modelName} in data object:`, dataObjectRef.value[modelName]);
		} else {
			console.debug(`Model '${modelName}' not found in data object.`);
		}
	} catch (error) {
		console.error('Error updating data model:', error);
	}
}

function valueCheck(event, dataObjectRef) {
	const object = event.target;

	// 디버깅: 전달된 객체가 무엇인지 콘솔에 출력
	console.log('Received dataObjectRef:', dataObjectRef);

	// `dataObjectRef.value`가 유효한지 확인
	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// `id` 속성을 사용하여 데이터 모델 속성 이름을 추론
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 입력 값이 비어 있는 경우 0으로 설정
	let newValue = object.value.trim();
	if (newValue.length < 1) {
		newValue = '0';
	} else {
		// 숫자 변환: 앞의 불필요한 0을 제거
		newValue = parseInt(newValue, 10).toString();
	}

	// DOM 업데이트
	object.value = newValue;

	// Vue 데이터 모델 업데이트
	if (modelName in dataObjectRef.value) {
		dataObjectRef.value[modelName] = newValue;
		console.log(`Updated ${modelName} in data object:`, dataObjectRef.value[modelName]);
	} else {
		console.debug(`Model '${modelName}' not found in data object.`);
	}
}

let old_mb_name = "";
let old_icon = "";
let old_email = "";
let old_phone1 = "010";
let old_phone2 = "";
let old_phone3 = "";
let ischanged_email = ref(false);
let ischanged_phone = ref(false);

const previousFileNames = {
	mb_img: '',
	mb_icon: ''
};
let uploadComplete = ref(false);

const updatePhoto = (type) => (e) => {
	const file = e.target.files[0];
	const limit = 1024 * 1024 * 3;
	const validTypes = type === 'mb_img' 
		? ['image/png', 'image/jpeg'] 
		: ['image/gif', 'image/jpeg', 'image/png'];
	
	// 파일이 선택되지 않은 경우
	if (!file) {
		// 파일이 선택되지 않은 경우에도 이전 파일 이름을 유지
		e.target.value = null;
		//e.target.previousFileName = previousFileNames[type]; // 유지할 파일 이름 설정
		return;
	}

	// 파일 타입 및 크기 검증
	if (!validTypes.includes(file.type)) {
		commonjs.uploadSwal('ext');
		e.target.value = '';
		return;
	}

	if (file.size > limit) {
		commonjs.uploadSwal('size');
		e.target.value = '';
		return;
	}

	const reader = new FileReader();
	form.value[type] = file;
	previousFileNames[type] = file.name;

	reader.onloadend = () => {
		const key = type.split('_')[1];

		if (key === 'img') {
			form.value.preview = reader.result;
		} else if (key === 'icon') {
			form.value.preview2 = reader.result;
		}

		uploadComplete.value = true;  // 파일 읽기 완료 시점 설정
	};

	// 파일 읽기 에러 처리
	reader.onerror = () => {
		commonjs.formSwal('파일 읽기 오류', '파일을 읽는 중 오류가 발생했습니다.', `#${type}`, 'self');
	};

	reader.readAsDataURL(file);
};

watch(
	() => [form.value.preview, form.value.preview2], ([nVal, nVal2], [oVal, oVal2]) => {
		if (nVal === undefined || nVal === null) {
		} else {
			if(uploadComplete.value && nVal) {
				if (nVal != oVal && nVal.includes('base64') && (nVal.includes('image/png') || nVal.includes('image/jpeg'))) {
//console.log(nVal.split('base64,')[1]);
					get_OCR_business(nVal.split('base64,')[1]);
				}
			}
		}

		if (nVal2 === undefined || nVal2 === null) {
		} else {
			if (nVal2 != oVal2 && nVal2.includes('base64') && (nVal2.includes('image/png') || nVal2.includes('image/jpeg') || nVal2.includes('image/gif'))) {
console.log('icon file 업로드');
			}
		}
	}, {
		immediate: false // 컴포넌트가 마운트될 때 즉시 실행
	}
)

watch(
	() => [form.value.phone2, form.value.phone3], ([nVal, nVal2], [oVal, oVal2]) => {
		if (nVal.length >= 3 && nVal2.length >= 4) {
			console.log('true1');
			if ((old_phone1 === form.value.phone1 && old_phone2 === nVal && old_phone3 === nVal2)) {
console.log('인증한 번호랑 같다.');
			} else {
				form.value.show_req_checknum_btn = true;
			}
		} else {
			form.value.show_req_checknum_btn = false;
		}
	}, {
		immediate: false // 컴포넌트가 마운트될 때 즉시 실행
	}
)

const resetPhoto2 = () => {
	form.value.mb_icon = null;
	form.value.preview2 = null;
	if (globaljs.mb_staff === null || globaljs.mb_staff.length > 6) {
		document.getElementById('reg_mb_icon').value = null;
	}

	// 파일 이름 초기화
	previousFileNames['mb_icon'] = '';
};

function sms_timer(mode) {
	timeout = false;
	let time = 300;
	let min = "";
	let sec = "";
	let x = setInterval(function () {
		min = parseInt(time / 60);
		sec = time % 60;
		document.getElementById("sms_timer").innerHTML = min + "분" + sec + "초";
		time--;

		if (time < 0) {
			clearInterval(x);
			document.getElementById("sms_timer").innerHTML = "시간 초과";
			timeout = true;
		}
	}, 1000);
}

const send_sms_to_phone = async (cert_hp, cert_code) => {
	let response_pre = await axios.get(`${SERVER_URL}/api/app/member/get_sms_maxid`);
	const sms_maxid = response_pre.data.result.max_id ? response_pre.data.result.max_id : 0;

	const api_url = "/hyphen/mn0109000725"; // 프록시를 사용한 URL
	const api_headers = {
		"Content-Type": "application/json",
		"user-id": "wetreecorp",
		"Hkey": "486c875fb8f848dd"
	};

	const data = {
		SEQ: `dencl-cert${sms_maxid}`,
		RECEIVER: cert_hp,
		SENDER: '0261058900',
		REQ_USER_ID: 'wetreecorp',
		REQ_DEPT_ID: 'hyphen',
		JONMUN: `[덴탈클라우드] 인증번호: ${cert_code} 인증번호를 입력해 주세요.`,
		AD_FLAG: 'N'
	};

	try {
		const response = await axios.post(api_url, data, {
			headers: {
			...api_headers,
			'Authorization': ''  // Authorization 헤더를 빈 값으로 설정하여 제거
			}
		});
		console.debug(response.data); // 인증번호 발송
		if (response.data && response.data.common.errYn === 'N') {
			commonjs.formSwal('인증번호 발송 완료', '휴대전화로 인증번호를 발송했습니다.');
		} else {
			commonjs.formSwal('인증번호 발송 오류', 'SMS 발송중 오류가 발생했습니다. \n(' + response.data.data.message + ')', '#phone2', 'self');
		}
	} catch (error) {
		console.error(error?.response?.data);
		commonjs.formSwal('인증번호 발송 요청 오류', 'SMS 발송 요청 중 오류가 발생했습니다.', '#phone2', 'self');
	}
};


const cert_sms_check = async () => { // 인증번호를 DB와 비교
	await withSubmitFlag(async () => {
		const params = new URLSearchParams();
		params.append('cert_hp', form.value.sended_hp);
		params.append('cert_code', form.value.checknum);
		// 240730 인증패스할때 파라미터 추가함
		let p2_num = parseInt(String(form.value.phone2).slice(0, 1));
		if (typeof p2_num === 'number' && p2_num > 2 && form.value.phone1 === '010') {
		} else {
			params.append('wetree', 'pass');
		}

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/member/cert_sms_check`, params);

			if (response.data.result.check) {
				const hp_arr = form.value.sended_hp.split('-');
				form.value.phone1 = hp_arr[0];
				form.value.phone2 = hp_arr[1];
				form.value.phone3 = hp_arr[2];

				form.value.hp_cert = 1;
				form.value.hp_check = 1;
				//form.value.readonly_phone = true;
				ischanged_phone.value = true;
				if (ischanged_phone.value) {
					form.value.mb_hp = form.value.sended_hp;
					form.value.certed_hp = form.value.mb_hp; // 인증완료한 번호를 저장
					old_phone1 = form.value.phone1;
					old_phone2 = form.value.phone2;
					old_phone3 = form.value.phone3;

					form.value.phone1 = '010';
					form.value.phone2 = '';
					form.value.phone3 = '';
				}
				document.querySelector('.phone_change_box').classList.remove('open');
				document.getElementById('checknum_wrap').classList.remove('on');
				form.value.show_req_checknum_btn = false;
				//document.getElementById('req_checknum_btn').classList.remove('on');

				document.getElementById('checknum_confirm').classList.remove('on');

				commonjs.formSwal('인증완료', '휴대전화 인증이 완료되었습니다.');
			} else {
				form.value.hp_cert = 0;
				form.value.hp_check = 1;
				form.value.readonly_phone = false;
				ischanged_phone.value = false;
				document.getElementById('checknum_wrap').classList.add('on');
				form.value.show_req_checknum_btn = true;
				//document.getElementById('req_checknum_btn').classList.add('on');

				document.getElementById('checknum_confirm').classList.add('on');

				commonjs.formSwal('인증실패', '정확한 인증번호를 입력해 주세요.', '#checknum', 'self');
			}

		} catch (error) {
	console.error(error?.response?.data);
			commonjs.formSwal('인증번호 요청 오류', '데이터 요청중 오류가 발생했습니다.', '#phone2', 'self');
		} 
	});
}

const req_checknum = async () => {
	await withSubmitFlag(async () => {
		if (form.value.show_req_checknum_btn && !form.value.readonly_phone) {
			console.log('req_checknum().if-pass');
			form.value.show_req_checknum_btn = false;
			setTimeout(() => {
				form.value.show_req_checknum_btn = true;
			}, 2000);

			try {
				await send_req();
			} catch (error) {
			console.error(error?.response?.data);
				commonjs.formSwal('인증번호 요청 오류', '데이터 요청중 오류가 발생했습니다.', '#phone2', 'self');
			}
		} else {
			return false;
		}
	});
}

const send_req = async () => {
	const v = form.value.phone1 + form.value.phone2 + form.value.phone3;
	form.value.sended_hp = `${form.value.phone1}-${form.value.phone2}-${form.value.phone3}`;

	const params = new URLSearchParams();
	params.append('cert_hp', v);
	params.append('mb_hp', form.value.sended_hp);
	if (globaljs.mb_id) {
		params.append('mb_id', globaljs.mb_id);
	}

console.log('send_req().ready');

	try {
		const response = await axios.post(`${SERVER_URL}/api/app/member/cert_sms_req`, params);
console.log('send_req().response', response);
		if (response.data.result.cert_code) {
			form.value.show_req_checknum_btn = false;
			document.getElementById('checknum_wrap').classList.add('on');
			document.getElementById('checknum').classList.add('on');

			let p2_num = parseInt(String(form.value.phone2).slice(0, 1));

			if (typeof p2_num === 'number' && p2_num > 2 && form.value.phone1 === '010') {
				await send_sms_to_phone(v, response.data.result.cert_code);
			} else {
				form.value.checknum = response.data.result.cert_code;
				document.getElementById("checknum_confirm").classList.add("on");
			}
		} else {
			form.value.show_req_checknum_btn = true;
			commonjs.formSwal('전송 실패', '오류가 발생해서 전송에 실패했습니다.' + response.data.result.message, '#phone2', 'self');
		}
	} catch (error) {
		commonjs.formSwal('인증번호 요청 오류', '데이터 요청 중 오류가 발생했습니다.', '#phone2', 'self');
		}
};

const email_check_submit = async () => { // 이메일 중복체크
	await withSubmitFlag(async () => {
		try {
			let result = await registerjs.email_check(form.value.mb_email);

			if (result === 'able') {
				form.value.email_cert = 1;
				form.value.email_check = 1;
				ischanged_email.value = true;

				form.value.checked_email = form.value.mb_email; // 중복체크한 이메일을 저장
				old_email = form.value.mb_email; // 중복체크한 이메일을 표시

				Swal.fire({
					title: '사용 가능',
					text: '[' + document.getElementById('mb_email').value + '] 사용가능한 이메일입니다',
					icon: 'success',
					confirmButtonText: '확인',
					allowOutsideClick: false,  // 외부 클릭 방지
					allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
					returnFocus: false,
				}).then((result) => {
					if (result.isConfirmed) {
						setTimeout(function () {
							document.getElementById('phone1').focus();
						}, 100);
					}
				});
			} else {
				form.value.email_cert = 0;
				form.value.email_check = 0;
				ischanged_email.value = false;

				let txt = '';
				let tit = '';
				if (result === 'exist') {
					tit = '사용 불가';
					txt = '이미 사용중인 이메일입니다';
				} else {
					tit = '이메일 입력 오류';
					txt = result;
				}

				Swal.fire({
					title: tit,
					text: txt,
					icon: 'error',
					confirmButtonText: '확인',
					// allowOutsideClick: false,  // 외부 클릭 방지
					// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
					returnFocus: true,
				});
			}
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}

const email_change_onclick = () => {
	form.value.email_check = document.querySelector('.email_change_box').classList.contains('open') ? 1 : 0;
}

const phone_change_onclick = () => {
	form.value.hp_check = document.querySelector('.phone_change_box').classList.contains('open') ? 1 : 0;
}

const email_oninput = (event) => {
	let email_check = document.getElementById('reg_mb_email_check');
	let emailRule = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

	form.value.email_check = 0;

	if (emailRule.test(form.value.mb_email) && form.value.mb_email !== old_email) {
		email_check.classList.add('on');
	} else {
		email_check.classList.remove('on');
	}

	handleMaxLengthCheck(event)
}

const myPageLoaded = () => {
	if (old_email !== '') {
		form.value.email_check = 1;
	}
}

onMounted(async () => {
	clientIP.value = await commonjs.getIpAddress();

	await getMyinfo();

	registerjs.DOMLoaded();
	myPageLoaded();

	document.getElementById('reg_mb_icon').addEventListener('change', updatePhoto('mb_icon'));
});

onBeforeUnmount(() => {
	document.getElementById('reg_mb_icon').addEventListener('change', updatePhoto('mb_icon'));
});

const getMyinfo = async () => {
	let response = await axios.get(`${SERVER_URL}/api/app/member/my`);
	const result = response.data.result;
console.debug(result);

	// form.value와 result의 공통된 필드만 덮어쓰기
	form.value = Object.assign({}, form.value, Object.keys(form.value).reduce((acc, key) => {
		if (result.hasOwnProperty(key)) {
			acc[key] = result[key];
		}
		return acc;
	}, {}));

	// 기존 데이터 필드에 대입
	old_icon = form.value.mb_icon || '';
	resetPhoto2(); // 240924 mb_icon은 비우게

	old_mb_name = form.value.mb_name;
	old_email = form.value.mb_email;
	old_phone1 = form.value.phone1;
	old_phone2 = form.value.phone2;
	old_phone3 = form.value.phone3;
	form.value.hp_cert = (old_phone1 != '' && old_phone2 != '' && old_phone3 != '') ? 1 : 0;
	form.value.email_cert = (old_email != '') ? 1 : 0;
	// 수정할 필드는 디폴트 초기화
	form.value.mb_email = "";
	form.value.phone1 = "010";
	form.value.phone2 = "";
	form.value.phone3 = "";
}

async function form_my_update_submit() {
	await withSubmitFlag(async () => {
		if (form.value.mb_password != '' || form.value.mb_password_re != '') {
			if (!registerjs.pwdRule.test(form.value.mb_password)) {
				commonjs.formSwal('비밀번호', '비밀번호', '#reg_mb_password', 'type');
				return false;
			}
			if (!registerjs.pwdRule.test(form.value.mb_password_re)) {
				commonjs.formSwal('비밀번호 확인', '비밀번호', '#reg_mb_password_re', 'type');
				return false;
			}
			if (form.value.mb_password != form.value.mb_password_re) {
				commonjs.formSwal('비밀번호 입력 오류', '비밀번호가 서로 다릅니다.', '#reg_mb_password', 'self');
				return false;
			}
		}
		if (!form.value.mb_name || form.value.mb_name.length < 1) {
			commonjs.formSwal('성명', '성명', '#reg_mb_name');
			return false;
		}

	if (globaljs.mb_staff === null || globaljs.mb_staff.length > 6) {
		if (form.value.email_cert === 0) {
			//if (form.value.email_check === 0) {
			commonjs.formSwal('이메일', '이메일', '#mb_email', 'exist');
			return false;
			//}
		}
		if (form.value.hp_cert === 0 || form.value.mb_hp === '') {
			if (form.value.hp_check === 0) {
				commonjs.formSwal('휴대전화', '휴대전화', '#phone3', 'cert');
				return false;
			}
			if (document.querySelector('.phone_change_box').classList.contains('open')) {
				if (!registerjs.phone2Rule.test(form.value.phone2)) {
					commonjs.formSwal('휴대전화번호', '휴대전화번호 가운데 자리(숫자3~4자리)', '#phone2', 'type');
					return false;
				}
				if (!registerjs.phone3Rule.test(form.value.phone3)) {
					commonjs.formSwal('휴대전화번호', '휴대전화번호 끝자리(숫자4자리)', '#phone3', 'type');
					return false;
				}
			}
		}

		if (!ischanged_email.value) {
			form.value.mb_email = old_email;
		}

		if (ischanged_email.value && form.value.checked_email && form.value.checked_email.length > 0) {
			// if (form.value.mb_email != form.value.checked_email) {
			// 	commonjs.formSwal('이메일', '중복확인한 이메일이 다릅니다. 다시 확인해주세요.', '#mb_email', 'self');
			// }
			form.value.mb_email = form.value.checked_email;
		}

		if (ischanged_phone.value && form.value.certed_hp && form.value.certed_hp.length > 0) {
			if (form.value.mb_hp != form.value.certed_hp) {
				commonjs.formSwal('휴대전화번호', '새로 인증한 번호가 다릅니다. 다시 인증해주세요.', '#phone2', 'self');
			}
			form.value.mb_hp = form.value.certed_hp;
		}

		if (!form.value.mb_tel || form.value.mb_tel.trim().length < 1) {
			commonjs.formSwal('대표 전화번호', '대표 전화번호', '#mb_tel');
			return false;
		}

		if (globaljs.acc_type === 'lab') {
			if (!form.value.mb_bank || form.value.mb_bank.length < 1) {
				commonjs.formSwal('은행명', '은행명', '#mb_bank');
				return false;
			}
			if (!form.value.mb_bank_acc || form.value.mb_bank_acc.trim().length < 1) {
				commonjs.formSwal('계좌번호', '계좌번호', '#mb_bank_acc');
				return false;
			}
			if (!form.value.mb_bank_name || form.value.mb_bank_name.length < 1) {
				commonjs.formSwal('예금주명', '예금주명', '#mb_bank_name');
				return false;
			}
		}
	}

		const formData = new FormData();
			formData.append("mb_staff", globaljs.mb_staff);
			formData.append("mb_id", form.value.mb_id);
			if (form.value.mb_password != '' || form.value.mb_password_re != '') {
				formData.append("mb_password", form.value.mb_password);
				formData.append("mb_password_re", form.value.mb_password_re);
			}
			formData.append("mb_name", form.value.mb_name);
		if (globaljs.mb_staff === null || globaljs.mb_staff.length > 6) {
			formData.append("mb_email", form.value.mb_email);
			formData.append("email_check", form.value.email_check);
			formData.append("mb_hp", form.value.mb_hp);
			formData.append("hp_cert", form.value.hp_cert);
			formData.append("hp_check", form.value.hp_check);
			formData.append("mb_tel", form.value.mb_tel);
			if (globaljs.acc_type === 'lab') {
				formData.append("mb_bank", form.value.mb_bank);
				formData.append("mb_bank_acc", form.value.mb_bank_acc);
				formData.append("mb_bank_name", form.value.mb_bank_name);
			}
			if (form.value.mb_icon != '') {
				formData.append("mb_icon", form.value.mb_icon);
			}
			if (form.value.del_mb_icon != '') { // 240924 프로필사진 삭제 체크하면.
				formData.append("del_mb_icon", form.value.del_mb_icon);
			}
			if (old_icon != '') {
				formData.append("old_icon", old_icon);
			}
		}
		// formData.append("mb_img", form.value.mb_img);

		// URLSearchParams를 객체로 변환
		const object = {};
		formData.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);
	// submitingFlag = false;
	// return false;
	
		const config = {
			headers: {
				"Content-Type": "multipart/form-data"
			},
		};

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/member/my`, formData, config);
	console.debug(response.data.result);
			globaljs.safeSetItem('mb_name', form.value.mb_name); // 240924 이름 변경한것도 스토리지에 반영되도록

			toast.fire({
				icon: "success",
				title: "정보 수정 완료!"
			});

			// 241024 성명 변경시 우측상단 이름이 반영되어야해서 수정함.
			if(old_mb_name !== form.value.mb_name) {
				/// 2초 후에 다음 로직을 실행
				setTimeout(() => {
					document.location.reload();
				}, 1000); // 2000ms = 2초
			} else {
				getMyinfo();
			}

	//		router.push("/");
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>